import type Store from '@ember-data/store';
import type EventLogModel from 'garaje/models/event-log';
import ApplicationSerializer from 'garaje/serializers/application';

interface EventLogApiItem {
  company_id: number;
  location_id: number | null;
  zone_id: number | null;
  metadata_version: string;
  location_name: string | null;
  event_timestamp: number;
  event_description: string;
  event_type: string;
  actor_name: string;
  actor_id: string;
  actor_type: string;
  group: string;
  target_name: string;
  target_type: string;
  target_id: string;
  service_name: string;
  ip_address: string;
  country: string | null;
  service_version: string;
  event: string;
}

interface EventLogApiResponse {
  items?: EventLogApiItem[];
  total?: number;
  page?: number;
  size?: number;
}

export default class EventLogSerializer extends ApplicationSerializer {
  normalizeResponse(
    store: Store,
    primaryModelClass: EventLogModel,
    payload: EventLogApiResponse,
    id: string | number | null,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeResponse']> {
    const jsonApiPayload = {
      data:
        payload.items?.map((item: EventLogApiItem, index: number) => ({
          type: 'event-log',
          id: `${item.company_id}-${item.event_timestamp}-${item.actor_id}-${index}`,
          attributes: {
            'company-id': item.company_id,
            'location-id': item.location_id,
            'zone-id': item.zone_id,
            'metadata-version': item.metadata_version,
            'location-name': item.location_name,
            'event-timestamp': item.event_timestamp,
            'event-description': item.event_description,
            'event-type': item.event_type,
            'actor-name': item.actor_name,
            'actor-id': item.actor_id,
            'actor-type': item.actor_type,
            group: item.group,
            'target-name': item.target_name,
            'target-type': item.target_type,
            'target-id': item.target_id,
            'service-name': item.service_name,
            'ip-address': item.ip_address,
            country: item.country,
            'service-version': item.service_version,
            event: item.event,
          },
        })) || [],
      meta: {
        total: payload.total || 0,
        page: payload.page || 0,
        size: payload.size || 0,
      },
    };

    return super.normalizeResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
  }
}
